import { useHttp } from '@/shared/lib'
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'

/**
 * Функция загрузки объектов для карт
 */
export const useLoadObjectsMap = () => {
  const http = useHttp()
  const route = useRoute()

  const url = computed(() => `/objects/${route.params.object_id}/map/object-items`)

  const queryKey = computed(() => ['load_objects_map', route.params.object_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}

/**
 * Функция загрузки объектов для карт
 */
export const useLoadGroupObjectsMap = () => {
  const http = useHttp()
  const route = useRoute()

  const url = computed(() => `/groups/${route.params.object_id}/map-objects`)

  const queryKey = computed(() => ['load_group_objects_map', route.params.object_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}
